import React, { useContext } from 'react';
import { MetadataContext, ModuleBase } from '@/components';
import { ModuleBaseModel, ModuleSectionPropsModel } from '@/types';
import SectionHeading from '@/components/general/SectionHeading';
import classNames from 'classnames';

type SectionHeadingModuleModel = ModuleBaseModel<
  {
    text: string;
    fitToPageWidth?: boolean;
  } & ModuleSectionPropsModel
>;

const SectionHeadingModule = (data: SectionHeadingModuleModel) => {
  const { fitToPageWidth, text, ...props } = data.props;
  const { isPublic } = useContext(MetadataContext);
  return (
    <ModuleBase data={data}>
      <div className="container">
        <SectionHeading
          data={{ ...props, summary: text }}
          className={classNames(
            'SectionHeading mx-auto flex w-full flex-col justify-center pb-8 md:pb-5 print:w-full [&_.summary]:pt-5',
            !fitToPageWidth && 'lg:w-3/4',
            !isPublic && 'color-from-bg [&_.heading]:font-light',
          )}
        />
      </div>
    </ModuleBase>
  );
};

export default SectionHeadingModule;
